import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './wrap.styl'

export default class Wrap extends Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    variableHeight: PropTypes.bool
  }

  render() {
    const { className, variableHeight } = this.props
    const classNames = [styles.wrap, className]
    variableHeight && classNames.push(styles.variableHeight)

    return (
      <div className={classNames.join(' ')}>
        {this.props.children}
      </div>
    )
  }
}
